import { FC } from 'react'
import { PatientUser } from '~/shared/types'
import NavigationList from './NavigationList'

interface NavigationProps {
  patient: PatientUser
}

/** Design-refresh Navigation tab. */
const Navigation: FC<NavigationProps> = props => {
  return <NavigationList person={props?.patient.person} />
}

export default Navigation
